import React, { useState } from "react";
import { NavLink } from "react-router-dom";

function MobileNavigation({logo, menuItems, ourseItems, t}) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCoursesOpen, setMobileCoursesOpen] = useState(false);

   return (
    <>
      <button className={`navigation__hamburger ${mobileOpen ? "is-open" : ""}`}
        onClick={() => setMobileOpen(prev => !prev)}>
        {mobileOpen ? "X" : "☰"}
      </button>

      {mobileOpen && (
        <>
          <div className="mobile-overlay" onClick={() => setMobileOpen(false)}/>
          <div className="mobile-menu">
            <button className="mobile-menu-link" onClick={() => setMobileCoursesOpen(prev => !prev)}>
              {t("courses")}
            </button>
            {mobileCoursesOpen && (
              <div className="mobile-submenu">
                <a href="https://vixacademy.com/courses#htmlcss" target="_blank" rel="noreferrer"> HTML & CSS </a>
                <a href="https://vixacademy.com/courses#python" target="_blank" rel="noreferrer"> PYTHON </a>
                <a href="https://vixacademy.com/courses#javascript" target="_blank" rel="noreferrer"> JAVA SCRIPT </a>
                <a href="https://vixacademy.com/courses#seo" target="_blank" rel="noreferrer"> SEO </a>
                <a href="https://vixacademy.com/courses#smm" target="_blank" rel="noreferrer"> SOCIAL MEDIA MARKETING </a>
                <a href="https://vixacademy.com/courses#fundamentals" target="_blank" rel="noreferrer"> TRADING FUNDAMENTALS </a>
              </div>
            )}

            <div className="mobile-menu-divider" />
            {menuItems.map((item, i) => (
              item.to ? (
                <NavLink
                  key={i}
                  to={item.to}
                  onClick={() => setMobileOpen(false)}
                  className="mobile-menu-link"
                >
                  {item.label}
                </NavLink>
              ) : (
                <button
                  key={i}
                  onClick={() => {
                    item.action?.();
                    setMobileOpen(false);
                  }}
                  className="mobile-menu-link"
                >
                  {item.label}
                </button>
              )
            ))}

          </div>
        </>
      )}
    </>
  );
}

export default MobileNavigation;
